import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';

import { RessourcesModule } from '@ressources/client/ressources.module';

export enum ProjectColors {
    AZURE = '#0079FF',
    CAPRI = '#00C4FF',
    CARIBBEAN_GREEN = '#00DFA2',
    LIGHT_BLUE = '#5B6CFF',
    GREEN = '#2BCB11',
    RED = '#FF1E1E',
    ORANGE = '#FF6D28',
    YELLOW = '#FBDF07',
    MUSTARD = '#E8AA0D',
    CYCLAMEN = '#F266AB',
    VIOLET = '#892CDC',
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-color-dropdown',
    styleUrl: './color-dropdown.component.scss',
    templateUrl: './color-dropdown.component.html',
})
export class ColorDropdownComponent {
    public readonly colorControl = input.required<FormControl<ProjectColors>>();
    public colors = Object.values(ProjectColors);
}
